import { DecoratedSpecialBannersList, TAdMaterialTagsList, TBannersList } from '../interfaces/advertising';
import { IMaterial } from '../interfaces/news';

import { getLowerCaseName } from './news';

interface IDecorateParams {
  banners: TBannersList;
  source: IMaterial;
  adTags: TAdMaterialTagsList;
}

export const decorateBannersForAds = ({ banners, source, adTags }: IDecorateParams) => {
  let additionalParams = {};
  if (source) {
    const { productTags, puid } = source;
    const tags = productTags?.reduce((acc, tag) => {
      return adTags[tag] ? [...acc, adTags[tag].alias] : acc;
    }, []);

    additionalParams = {
      teg: puid ?? tags,
    };
  }

  return Object.entries(banners).reduce((acc, [key, bannersList]) => {
    const newKey = getLowerCaseName(key);

    const decoratedList = bannersList.map((bannerFromList) => {
      if (bannerFromList.source === 'google' && source) {
        return {
          ...bannerFromList,
          ...(bannerFromList.targeting?.dfp && {
            targeting: {
              ...bannerFromList.targeting,
              dfp: decorateParams(bannerFromList.targeting.dfp, source, additionalParams),
            },
          }),
        };
      }

      if (bannerFromList.source === 'yandex' && source) {
        return {
          ...bannerFromList,
          params: decorateParams(bannerFromList.params, source, additionalParams),
        };
      }

      return bannerFromList;
    });

    return {
      ...acc,
      [newKey]: decoratedList,
    };
  }, {});
};

const decorateParams = (target, source, additionalParams) => {
  return {
    ...target,
    alias: source.alias,
    page_type: source.page_type,
    rubrika: source.rubric,
    pm: source.hideAds,
    teg: source.tags?.[0],
    ...additionalParams,
  };
};

export const decorateSpecialOffersBanners = (banners: TBannersList): DecoratedSpecialBannersList => {
  let decoratedBanners = banners as DecoratedSpecialBannersList;

  const specialProjectBanner = decoratedBanners?.teaserInPropositions?.[0];

  if (specialProjectBanner) {
    decoratedBanners.teaserInPropositions = [];

    for (let i = 1; i <= 4; i++) {
      decoratedBanners.teaserInPropositions.push({
        ...specialProjectBanner,
        params: {
          ...specialProjectBanner.params,
          order: i,
        },
      });
    }
  }

  return decoratedBanners;
};
